module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    attrs: {
      "for": "searchTextEdit"
    }
  }, [_vm._v("Search for")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.searchText),
      expression: "value.searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "searchTextEdit",
      "placeholder": "Enter text to find",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.searchText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "searchText", $event.target.value)
      }
    }
  }), _c('label', {
    attrs: {
      "for": "replaceTextEdit"
    }
  }, [_vm._v("Replace with ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.replaceText),
      expression: "value.replaceText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "replaceTextEdit",
      "placeholder": "Enter text to replace with"
    },
    domProps: {
      "value": (_vm.value.replaceText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "replaceText", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v("Target")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.targetType),
      expression: "value.targetType"
    }],
    attrs: {
      "type": "radio",
      "value": "Node names",
      "checked": "checked",
      "id": "nodeNameTargetRadio"
    },
    domProps: {
      "checked": _vm._q(_vm.value.targetType, "Node names")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "targetType", "Node names")
      }
    }
  }), _c('span', [_vm._v("Node names")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.targetType),
      expression: "value.targetType"
    }],
    attrs: {
      "type": "radio",
      "value": "Link commodities",
      "id": "commodityTargetRadio"
    },
    domProps: {
      "checked": _vm._q(_vm.value.targetType, "Link commodities")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "targetType", "Link commodities")
      }
    }
  }), _c('span', [_vm._v("Commodities")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.targetType),
      expression: "value.targetType"
    }],
    attrs: {
      "type": "radio",
      "value": "Link units",
      "id": "unitsTargetRadio"
    },
    domProps: {
      "checked": _vm._q(_vm.value.targetType, "Link units")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "targetType", "Link units")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Units")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancelButtonClick
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": !_vm.areSettingsValid()
    },
    on: {
      "click": _vm.okButtonClick
    }
  }, [_vm._v("Execute")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9e87a000", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e87a000"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/search-and-replace-dialog/search-and-replace-dialog.vue.html
// module id = 1127
// module chunks = 0